var toString = {}.toString;
var getType = function (value) {
    return toString.call(value).replace(/^\[object /, '').replace(/]$/, '');
};
export default getType;
//# sourceMappingURL=get-type.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/get-type.js
// module id = 144
// module chunks = 3